import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type POSPrinterMethod = 'system' | 'webusb' | 'webserial'
export type POSReceiptWidth = '58mm' | '80mm'

interface POSPrinterStore {
  method: POSPrinterMethod
  receiptWidth: POSReceiptWidth
  autoPrintOnPayment: boolean
  lastDetectedAt: string | null
  lastPrinterLabel: string | null
  setMethod: (method: POSPrinterMethod) => void
  setReceiptWidth: (width: POSReceiptWidth) => void
  setAutoPrintOnPayment: (enabled: boolean) => void
  setLastPrinter: (label: string | null) => void
}

export const usePOSPrinterStore = create<POSPrinterStore>()(
  persist(
    (set) => ({
      method: 'system',
      receiptWidth: '80mm',
      autoPrintOnPayment: false,
      lastDetectedAt: null,
      lastPrinterLabel: null,

      setMethod: (method) => set({ method }),
      setReceiptWidth: (receiptWidth) => set({ receiptWidth }),
      setAutoPrintOnPayment: (autoPrintOnPayment) => set({ autoPrintOnPayment }),
      setLastPrinter: (lastPrinterLabel) => set({
        lastPrinterLabel,
        lastDetectedAt: lastPrinterLabel ? new Date().toISOString() : null,
      }),
    }),
    {
      name: 'pos-printer-store',
      partialize: (state) => ({
        method: state.method,
        receiptWidth: state.receiptWidth,
        autoPrintOnPayment: state.autoPrintOnPayment,
        lastDetectedAt: state.lastDetectedAt,
        lastPrinterLabel: state.lastPrinterLabel,
      }),
    },
  ),
)
